import { useTranslation } from 'react-i18next'
import { generatePath } from 'react-router-dom'

import {
  RelatedList,
  RelatedListItem,
  RelatedSettings as RelatedSettingsContainer,
} from 'components/RelatedSettings'
import { useWorkspaceParam } from 'features/workspace/hooks/useWorkspaceParam'
import { ROUTES } from 'routes'

import type { DomainPrebidStack } from 'features/inventory/domain/types/domainPrebidStack'

type Props = Pick<DomainPrebidStack, 'syncDelay'>

export const SyncDelayRelatedSettings = ({ syncDelay }: Props): React.JSX.Element => {
  const { t: tc } = useTranslation('common', {
    keyPrefix: 'definedState',
  })
  const { t } = useTranslation('features/domain', {
    keyPrefix: 'form.prebidStack.advancedPrebidSettings',
  })

  const { workspaceId } = useWorkspaceParam()

  return (
    <RelatedSettingsContainer title={t('relatedSettings.title')}>
      <RelatedList>
        <RelatedListItem
          content={
            syncDelay === undefined
              ? t('relatedSettings.syncDelayEmpty', { value: tc('false') })
              : t('relatedSettings.syncDelay', { value: syncDelay })
          }
          url={generatePath(ROUTES.GLOBAL_SETUP.DEFAULTS.ROOT, {
            tab: 'prebid-stack',
            workspaceId,
          })}
        />
      </RelatedList>
    </RelatedSettingsContainer>
  )
}
